import { Box } from "components/Box";
import { Card } from "components/Card";
import { Typography } from "components/Typography";
import { useDropdown } from "hooks/dropdown";
import React from "react";
import styled from "styled-components";

export interface IDropdown {
  items: Array<{
    label: string;
    onClick: () => any;
  }>;
  children?: React.ReactNode;
  handleMenuButtonClick: () => void;
}

const Root = styled.div`
  position: relative;
`;

const WrapperChildren = styled.div`
  cursor: pointer;
`;

const WrapperDropdown = styled.div`
  ${({ theme }) => `
    right: 0;
    position: absolute;
    top: 100%;
    margin-top: ${theme.space[2]}px;
    min-width: 180px;
    z-index: 1000;
  `}
`;

const StyledTypography = styled(Typography)`
  ${({ theme }) => `
    padding: ${theme.space[2]}px 0px;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      color: ${theme.palette.primary.dark};
    }
  `}
`;

export const Dropdown: React.FC<IDropdown> = ({
  items,
  handleMenuButtonClick,
  children,
}) => {
  const { buttonRef, optionsRef, isVisible, setIsVisible } = useDropdown(false);

  const handleClick = (onClick: () => any) => () => {
    onClick();
    setIsVisible(false);
    handleMenuButtonClick();
  };

  return (
    <Root>
      <WrapperChildren ref={buttonRef} role="button" aria-hidden="true">
        {children}
      </WrapperChildren>
      {isVisible && (
        <WrapperDropdown ref={optionsRef}>
          <Card>
            <Box p={5}>
              {items.map(({ label, onClick }) => (
                <div
                  key={label}
                  onClick={handleClick(onClick)}
                  aria-hidden="true"
                  role="button"
                >
                  <StyledTypography variant="body">{label}</StyledTypography>
                </div>
              ))}
            </Box>
          </Card>
        </WrapperDropdown>
      )}
    </Root>
  );
};
